import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { withMicrositeProps } from '@dustin-web/microsite-nextjs/src/with-server-data/with-microsite-props'
import { withMicrositeWrapper } from '@dustin-web/microsite-nextjs/src/with-server-data/with-microsite-wrapper'
import { useRouter } from 'next/router'
import React from 'react'
import { OciDataState } from 'src/graphql/generated/graphql-types'

const Error = () => {
  const router = useRouter()
  const { translate } = useTranslations()

  const query = router?.query
  const state = query.state ? (query.state as OciDataState) : null

  return (
    <div className="u-pt-64 u-pb-64" style={{ minHeight: '62vh' }}>
      <div
        className="container"
        style={{
          color: '#000',
          textAlign: 'center',
        }}>
        <h1>{translate('Oci_Error_Title')}</h1>

        {state && <h2>{translate(`Oci_Error_State_${state}`)}</h2>}
      </div>
    </div>
  )
}

export const getServerSideProps = withMicrositeProps(async () => {
  return { props: {} }
})

export default withMicrositeWrapper(Error)
